import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Header from '../../components/Header';
import ResponsiveTableRegion from '../../components/ResponsiveTableRegion';
import Filters from '../../components/Filters';
import SearchableSelect from '../../components/SearchableSelect';
import LabeledSelectionCheckbox from '../../components/LabeledSelectionCheckbox';
import { ventrisConfig } from '../../ventris.config';

import TestPageIcon from '../../icons/TestPageIcon';
import { getUseCaseTerminology } from '../../useCase';
import FilterIcon from '../../icons/FilterIcon';
import ArchiveIcon from '../../icons/ArchiveIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import TestIcon from '../../icons/TestIcon';
import { completedTestDestination, launchableAssessmentsForUser } from '../../assessmentAccess';

type ClinicianTestsProps = {
};

let searchDebounce: any = null;

function ClinicianTests({}: ClinicianTestsProps) {
  const terms = getUseCaseTerminology();
  const [user, setUser] = useState([] as any);
  const [tests, setTests] = useState([] as any);
  const [selectedTestIds, setSelectedTestIds] = useState([] as any);
  const [showFilters, setShowFilters] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showLaunchTest, setShowLaunchTest] = useState(false);
  const [students, setStudents] = useState([] as any);
  const [student, setStudent] = useState("" as any);
  const [test, setTest] = useState(3 as any);

  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(20);
  const [totalSize, setTotalSize] = useState(0);
  const [sortFieldName, setSortFieldName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [clinicianFilter, setClinicianFilter] = useState("");
  const [studentFilter, setStudentFilter] = useState("");
  const [testFilter, setTestFilter] = useState("");
  const [completionStatusFilter, setCompletionStatusFilter] = useState("");
  const [archivedFilter, setArchivedFilter] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadTests(1);

    let currentUser = sessionStorage.getItem("current_user");
    const parsedUser = JSON.parse(currentUser!);
    setUser(parsedUser);
    const firstAssessment = launchableAssessmentsForUser(parsedUser)[0];
    if (firstAssessment) setTest(firstAssessment.schemaId);

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/students?sizePerPage=1000', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setStudents(data.students);
      if (data.students.length > 0) {
        setStudent(data.students[0].id);
      }
    });
  }, []);

  useEffect(() => {
      loadTests(page);
  }, [page, sizePerPage, sortFieldName, sortDirection, organizationFilter, clinicianFilter, studentFilter, testFilter, completionStatusFilter, archivedFilter]);

  useEffect(() => {
    if (searchDebounce) {
      clearTimeout(searchDebounce);
    }

    searchDebounce = setTimeout(() => {
      setPage(1);
      loadTests(1);
    }, 500);
  }, [search]);

  const loadTests = (page: number) => {
    setTimeout(() => {
      let token = sessionStorage.getItem("token");
      console.log(page);
      
      fetch(ventrisConfig.url + '/api/tests?page=' + page + '&sizePerPage=' + sizePerPage + '&sortField=' + sortFieldName + '&sortDirection=' + sortDirection + '&organization=' + organizationFilter + '&clinician=' + clinicianFilter + '&student=' + studentFilter + '&test=' + testFilter + '&completionStatus=' + completionStatusFilter + '&archived=' + archivedFilter + '&search=' + search, {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        setTests(data.tests);
        setTotalSize(data.total_records);
        setSelectedTestIds([]);
      });
    },
    100);
  }
  const loadTest = (name: any, testId: any) => {
    document.location.href = "/test/" + name + "/" + testId;
  }

  const loadStudent = (studentId: any) => {
    document.location.href = "/student/" + studentId;
  }

  const actuallyDeleteTests = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/delete', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        tests: selectedTestIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setShowDeleteModal(false);
      setShowArchiveModal(false);
      setPage(1);
      loadTests(1);
    });
  }

  const actuallyArchiveTests = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + (archivedFilter === 'true' ? 'unarchive' : 'archive'), {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        tests: selectedTestIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setShowDeleteModal(false);
      setShowArchiveModal(false);
      setPage(1);
      loadTests(1);
    });
  }

  const startNewTest = () => {
    const id = Number(test);
    const assessment = launchableAssessmentsForUser(user).find((option) => option.schemaId === id);
    if (!assessment) return;
    const name = assessment.name;

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: name,
        status: "Incomplete",
        test_schema_id: id,
        organization_id: user.organization_id,
        student_id: student,
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      if (data.success && data.test?.id) {
        document.location.href = "/test/" + name + "/" + data.test.id;
        return;
      }

      alert(data.message || "Unable to start a new test.");
    });
  }

  const toggleSelectedTest = (testId: string | number) => {
    const normalizedId = String(testId);
    setSelectedTestIds((prev: any) =>
      prev.includes(normalizedId)
        ? prev.filter((item: any) => item !== normalizedId)
        : [...prev, normalizedId]
    );
  }

  const checkboxFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
    const { selectedTestIds, toggleSelectedTest } = formatExtraData;
    return <LabeledSelectionCheckbox
      id={`test-select-${row.id}`}
      label={`Select ${row.name} test for ${row.student_first_name} ${row.student_last_name}`}
      checked={selectedTestIds.includes(String(row.id))}
      onChange={() => toggleSelectedTest(row.id)}
    />;
  }

  const studentNameFormatter = (cell: any, row: any) => {
    return (
      <div>
        <Button variant="link" size="sm" onClick={() => loadStudent(row.student_id)}>{cell}</Button>
      </div>
    );
  }

  const dateFormatter = (cell: any, row: any) => {
    return (
      <div>
        {(new Date(Date.parse(cell))).toLocaleDateString()}
      </div>
    );
  }

  const updatedFormatter = (cell: any, row: any) => {
    if (!cell) {
      return "";
    }

    const parsedDate = new Date(cell);
    if (isNaN(parsedDate.getTime())) {
      return cell;
    }

    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const year = parsedDate.getFullYear();

    let hours = parsedDate.getHours();
    const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const hoursString = String(hours).padStart(2, "0");

    return (
      <div>
        {`${month}/${day}/${year} ${hoursString}:${minutes} ${ampm}`}
      </div>
    );
  }

  const actionFormatter = (cell: any, row: any) => {
    return (
      <div>
        <Button variant="link" size="sm" onClick={() => row.status === "Complete" ? document.location.href = completedTestDestination(row) : loadTest(row.name, row.id)}>{row.status === "Complete" ? "Show Results" : "Continue Test"}</Button>
      </div>
    );
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Select',
      headerFormatter: () => <span className="visually-hidden">Select tests</span>,
      formatter: checkboxFormatter,
      formatExtraData: { selectedTestIds, toggleSelectedTest }
    },
    {
      dataField: 'name',
      text: 'Test',
      sort: true
    },
    {
      dataField: 'student',
      text: `${terms.student} Code`,
      sort: true,
      formatter: studentNameFormatter
    },
    {
      dataField: 'student_first_name',
      text: 'First Name',
      sort: true
    },
    {
      dataField: 'student_last_name',
      text: 'Last Name',
      sort: true
    },
    {
      dataField: 'completed_timestamp',
      text: 'Date Administered',
      formatter: dateFormatter
    },
    {
      dataField: 'updated_at',
      text: 'Last Updated',
      formatter: updatedFormatter
    },
    {
      dataField: 'clinician',
      text: 'Examiner',
      sort: true
    },
    {
      dataField: 'id',
      text: 'Action',
      formatter: actionFormatter
    }
  ];

  const handleTabChange = (tabKey: string | null) => {
    if (tabKey === 'view-all') {
      setCompletionStatusFilter("");
      setArchivedFilter("");
    } else if (tabKey === 'completed') {
      setCompletionStatusFilter("Complete");
      setArchivedFilter("false");
    } else if (tabKey === 'in-progress') {
      setCompletionStatusFilter("Incomplete");
      setArchivedFilter("false");
    } else if (tabKey === 'archived') {
      setCompletionStatusFilter("");
      setArchivedFilter("true");
    }
    setPage(1);
  }

  const updateFilters = (organizations: any, clinician: string, student: string, test: string, status: string, subtest: string, norms: string) => {
    setOrganizationFilter(organizations);
    setClinicianFilter(clinician);
    setStudentFilter(student);
    setTestFilter(test);
    setCompletionStatusFilter(status);
    setPage(1);
  };

  const handleTableChange = (type: string, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }: any) => {
    if ((sortField && sortFieldName != sortField) || (sortDirection && sortDirection != sortOrder)) {
      setPage(1);
    } else {
      setPage(page);
    }
    setPage(page);
    setSortFieldName(sortField ? sortField : "");
    setSortDirection(sortOrder ? sortOrder : "");
  }

  return (
    <Container fluid className="ventris-content-wrapper ventris-tests">
      <Header portal={sessionStorage.getItem("portal")!} page="tests" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <div className="page-header align-items-center tests-page-header">
              <h1 className="tests-page-title">
                <TestPageIcon />
                <span>Tests</span>
              </h1>
              <Form.Control type="search" className="ventris-search" aria-label="Search tests" placeholder="Search tests" value={search} onChange={(event) => setSearch(event.target.value)} />
              <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal" onClick={() => setShowLaunchTest(true)}><TestIcon /> Launch a New Test</Button>
            </div>
            <div className={showFilters ? '' : 'hidden'}>
              <Filters updateFilters={updateFilters} hideFilters={['Subtest', 'Norms']} />
            </div>
            <div className="table-list-toolbar">
              <div className="flex-grow">
                <Tabs defaultActiveKey="view-all" onSelect={(event) => handleTabChange(event)}>
                  <Tab eventKey="view-all" title="View All">
                  </Tab>
                  <Tab eventKey="completed" title="Completed">
                  </Tab>
                  <Tab eventKey="in-progress" title="In Progress">
                  </Tab>
                  <Tab eventKey="archived" title="Archived">
                  </Tab>
                </Tabs>
              </div>
              <div className="ventris-action-links">
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> {showFilters ? 'Hide Filter' : 'Show Filter'}</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowArchiveModal(true)}><ArchiveIcon /> {archivedFilter === 'true' ? 'Unarchive' : 'Archive'} Selected</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowDeleteModal(true)}><DeleteIcon /> Delete Selected</Button>
              </div>
            </div>
            <ResponsiveTableRegion label="Tests" className="tests-list-table">
              <BootstrapTable keyField='id' data={tests} columns={columns} bordered={true} remote={{pagination: true}} pagination={paginationFactory({ page, sizePerPage, totalSize })} onTableChange={handleTableChange} />
            </ResponsiveTableRegion>
          </Col>
        </Row>
      </Container>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete these item(s)? Deletion is permanent and cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => actuallyArchiveTests()}>No, Archive Instead</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyDeleteTests()}>Yes, Confirm Delete</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showArchiveModal} onHide={() => setShowArchiveModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to {archivedFilter === 'true' ? 'unarchive' : 'archive'} these item(s)?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => setShowArchiveModal(false)}>No, Cancel</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyArchiveTests()}>Yes, Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas show={showLaunchTest} onHide={() => setShowLaunchTest(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="tests-launch-test-title">
          <Offcanvas.Header className="offcanvas-header-green" closeButton>
              <Offcanvas.Title id="tests-launch-test-title">Launch a Test</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <p>To start a new test, select a {terms.student.toLowerCase()} from the drop-down list, then click one of the green buttons below. If a {terms.student.toLowerCase()} doesn&apos;t appear in the list, go to {terms.students} to create one, then return to this screen.</p>
            <br />
            {students.length > 0 ?
            <>
              <Form.Group className="mb-3 ventris-form-element" controlId="student">
                  <Form.Label>{terms.student}:</Form.Label>
                  <SearchableSelect
                    ariaLabel={terms.student}
                    options={[...students]
                      .sort((a: any, b: any) =>
                        (a.last_name || "").localeCompare(b.last_name || "") ||
                        (a.first_name || "").localeCompare(b.first_name || "")
                      )
                      .map((student: any) => ({
                        value: student.id,
                        label: `${student.last_name}, ${student.first_name} (${student.student_code})`
                      }))}
                    value={student}
                    onChange={setStudent}
                    placeholder={`Select ${terms.student.toLowerCase()}`}
                    searchPlaceholder={`Search ${terms.students.toLowerCase()}...`}
                  />
              </Form.Group>
              <Form.Group className="mb-3 ventris-form-element" controlId="test">
                  <Form.Label>Test:</Form.Label>
                  <Form.Select required aria-label="Test" value={test} onChange={(event) => setTest(event.target.value)}>
                    {launchableAssessmentsForUser(user).map((assessment) => <option key={assessment.name} value={assessment.schemaId}>{assessment.name}</option>)}
                  </Form.Select>
              </Form.Group>
              <br /><br />
              <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width" onClick={startNewTest}>Launch Test</Button>
            </> :
            <>
              Before you can start a test, you must add a student:
              <br /><br />
              <Link to="/students" className="ventris-button-secondary ventris-button-secondary-teal full-width">Manage {terms.students}</Link>
            </> }
          </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default ClinicianTests;
